<template>
  <div>
    <Row>
      <Col span="22">
        <FormItem :label="$t( 'resourceLifecycle.cloudPlatformSpecifications' )">
          <Table :no-data-text="$t('common.noData')" :columns="columns" :data="cloudPlatformSpecificationsDate"></Table>
        </FormItem>
      </Col>
    </Row>
  </div>
</template>

<script>

  export default {
    name: 'AzureVirtualMachine',
    props: ['azureResourceApplicationBasicInfoForm', 'cost'],
    components: {},
    data() {
      return {
        currentChoose: 0,
        modal_loadings: false,
        diskTypeList: [],
        lifecycleResource: {},
        resourceApplicationForm: {
          name: '',
          calculationSpecifications: '',
          instanceType: '',
          cpu: 0,
          memory: 0,
          diskType: '',
          diskSize: 100,
          cost: 0
        },
        ruleValidate: {
          name: [
            {required: true, message: this.$t( 'resourceLifecycle.namecannotbeempty' ), trigger: 'blur'}
          ],
          numberOfInstances: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseenterthenumberofinstances' ), trigger: 'blur', type: 'number'}
          ],
          os: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselecttheoperatingsystem' ), trigger: 'change', type: 'number'}
          ],
          mirror: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectamirror' ), trigger: 'change', type: 'number'}
          ],
          subnet: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectsubnet' ), trigger: 'change'}
          ],
          vpc: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectnetwork' ), trigger: 'change'}
          ],
          automaticallyAssignPublicIP: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectAutoAssignPublicIP' ), trigger: 'change'}
          ],
          securityGroup: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectasecuritygroup' ), trigger: 'change'}
          ],
          userName: [
            {required: true, message: this.$t( 'resourceLifecycle.usernamecannotbeempty' ), trigger: 'blur'}
          ],
          password: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseenterapassword' ), trigger: 'blur'}
          ],
          diskType: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectOSDiskType' ), trigger: 'change'}
          ]
        },
        columns: [
          {
            title: this.$t( 'resourceLifecycle.selects' ),
            key: 'vmName',
            width: 70,
            align: 'center',
            render: (h, params) => {
              let vmName = params.row.vmName;
              let cpu = params.row.cpu;
              let memory = params.row.memory;
              let flag = false;
              if (this.resourceApplicationForm.instanceType === vmName) {
                flag = true
              } else {
                flag = false
              }
              let self = this
              return h('div', [
                h('Radio', {
                  props: {
                    value: flag
                  },
                  on: {
                    'on-change': () => {
                      self.resourceApplicationForm.instanceType = vmName;
                      self.resourceApplicationForm.cpu = cpu;
                      self.resourceApplicationForm.memory = memory;
                      self.queryAzureVmPrice();
                    }
                  }
                })
              ])
            }
          },
          {
            title: this.$t( 'resourceLifecycle.models' ),
            key: 'vmName'
          },
          {
            title: this.$t( 'resourceLifecycle.numberofCPUcores' ),
            key: 'cpu'
          },
          {
            title: this.$t( 'resourceLifecycle.memoryGB' ),
            key: 'memory'
          }],
        cloudPlatformSpecificationsDate: []
      }
    },
    mounted: function () {
      this.showAll()
    },
    methods: {
      showAll: function () {
        this.queryLifecycleResourceById();
      },
      queryLifecycleResourceById: function () {
        if (this.azureResourceApplicationBasicInfoForm.resourceId == undefined) {
          return;
        }
        this.$api.lifecycleResourceApplication.queryLifecycleResourceById({
          "id": this.azureResourceApplicationBasicInfoForm.resourceId
        })
          .then(res => {
            this.lifecycleResource = res.data;
            this.listAzureVirtualMachineSizes();
          })
      },
      queryAzureVmPrice: function () {
        this.$api.azurePrice.queryAzureVMPrice({
          "osType": this.lifecycleResource.lifecycleResourceInstanceDTO.lifecycleResourceInstanceOsDTO.osPlatform,
          "duration": this.lifecycleResource.duration,
          "region": this.lifecycleResource.region,
          "lifecycleResourceInstanceDTO": {
            "instanceType": this.lifecycleResource.lifecycleResourceInstanceDTO.instanceType,
            "cpu": this.lifecycleResource.lifecycleResourceInstanceDTO.cpu,
            "ram": this.lifecycleResource.lifecycleResourceInstanceDTO.ram,
            "instanceNumber": this.lifecycleResource.lifecycleResourceInstanceDTO.instanceNumber
          }
        })
          .then(res => {
            this.resourceApplicationForm.cost = res.data
            this.$emit('success', this.resourceApplicationForm.cost);
          })
      },
      //获取Azure虚拟机机型列表
      listAzureVirtualMachineSizes: function () {
        this.$api.lifecycleResourceApplication.listAzureVirtualMachineSizes({
          "accountId": this.lifecycleResource.accountId,
          "location": this.lifecycleResource.region
        })
          .then(res => {
            this.cloudPlatformSpecificationsDate = res.data;
          })
      }
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_change/azure/virtual_machine/AzureVirtualMachine.vue